import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

import { createVuetify } from "vuetify";

// Default themes. The runtime primary color is overridden by useOrganization
// once the user logs in and the Organization metadata is loaded.
const lightTheme = {
  dark: false,
  colors: {
    primary: "#1976D2",
    secondary: "#424242",
    surface: "#FFFFFF",
    background: "#F5F5F5",
  },
};

const darkTheme = {
  dark: true,
  colors: {
    primary: "#1976D2",
    secondary: "#424242",
    surface: "#1E1E1E",
    background: "#121212",
  },
};

export default createVuetify({
  theme: {
    // 実際の初期テーマは stores/themeStore.js が起動時に上書きする。
    // 食い違うと読む人が混乱するので既定を揃えてある。
    defaultTheme: "light",
    themes: {
      light: lightTheme,
      dark: darkTheme,
    },
  },
});
